import { render, staticRenderFns } from "./CreateMuseumType.vue?vue&type=template&id=66598910&scoped=true"
import script from "./CreateMuseumType.vue?vue&type=script&lang=js"
export * from "./CreateMuseumType.vue?vue&type=script&lang=js"
import style0 from "./CreateMuseumType.vue?vue&type=style&index=0&id=66598910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66598910",
  null
  
)

export default component.exports